import React from "react";

export default function FilterIndicator({
  className = "",
  color = "var(--white)",
  status = "zero",
  width = 20,
  onClick = () => {},
}) {
  // status can be one of zero/full/partial
  let bgColor;
  let borderWidth = `1px`;
  switch (status) {
    case "zero":
      bgColor = `transparent`;
      break;
    case "partial":
      // bgColor = `var(--light-gray)`;
      borderWidth = `4px`;
      break;
    case "full":
      bgColor = color;
      break;
    default:
      bgColor = color;
      break;
  }
  return (
    <div
      className={`${className}`}
      onClick={onClick}
      style={{
        width,
        height: width,
        backgroundColor: bgColor,
        borderRadius: `50%`,
        border: `${borderWidth} solid ${color}`,
      }}
    />
  );
}
